import axios from './axios';

export default {
  update: (params) => axios.put(`/local_it_it_operateurs/${params.id}`, {
    local_it_it_operateur: params,
  }),
};
